// Auto-selects the correct env config based on NODE_ENV
// Usage: import { envConfig } from '@/config';

import { envConfig as devConfig } from './envConfig';
import { envConfig as prodConfig } from './envConfig.production';

export const envConfig =
  process.env.NODE_ENV === 'production' ? prodConfig : devConfig;
